// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wai-intro-notice {
  position: fixed;
  z-index: 10020;
  width: 19rem;
  padding: 0.9rem 0.9rem 0.75rem;
  border: 1px solid #60a5fa;
  border-radius: 0.7rem;
  background: #eff6ff;
  color: #1e3a5f;
  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.2);
  box-sizing: border-box;
}

.wai-intro-notice--left {
  transform: translate(-100%, -50%);
}

.wai-intro-notice--below::after,
.wai-intro-notice--left::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border: 0.45rem solid transparent;
}

.wai-intro-notice--left::after {
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  border-left-color: #60a5fa;
}

.wai-intro-notice--below::after {
  left: 1.5rem;
  bottom: 100%;
  border-bottom-color: #60a5fa;
}

.wai-intro-notice__close {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.7rem;
  height: 1.7rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #60a5fa;
  cursor: pointer;
}

.wai-intro-notice__close:hover {
  color: #1d4ed8;
}

.wai-intro-notice__close svg {
  width: 1rem;
  height: 1rem;
}

.wai-intro-notice__message {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  padding-right: 1.15rem;
}

.wai-intro-notice__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
  overflow: hidden;
  border: 1px solid rgba(209, 213, 219, 0.95);
  border-radius: 999px;
  background: #ffffff;
}

.wai-intro-notice__avatar svg {
  display: block;
  width: 100%;
  height: 100%;
}

.wai-intro-notice__message strong {
  display: block;
  margin-bottom: 0.2rem;
  font-size: 0.84rem;
}

.wai-intro-notice__message p {
  margin: 0;
  font-size: 0.76rem;
  line-height: 1.45;
}

.wai-intro-notice__dismiss {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-top: 0.65rem;
  padding-top: 0.55rem;
  border-top: 1px solid rgba(37, 99, 235, 0.18);
  font-size: 0.68rem;
  color: #475569;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.wai-intro-notice__dismiss input {
  width: 0.9rem;
  height: 0.9rem;
  margin: 0;
  accent-color: #2563eb;
  cursor: pointer;
}

.wai-intro-notice--dark {
  border-color: #3b82f6;
  background: #172554;
  color: #dbeafe;
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.4);
}

.wai-intro-notice--dark.wai-intro-notice--left::after {
  border-left-color: #3b82f6;
}

.wai-intro-notice--dark.wai-intro-notice--below::after {
  border-bottom-color: #3b82f6;
}

.wai-intro-notice--dark .wai-intro-notice__dismiss {
  border-top-color: rgba(96, 165, 250, 0.22);
  color: #bfdbfe;
}
`, "",{"version":3,"sources":["webpack://./src/components/report/WorkingAllianceIntroNotice.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;EAC7C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB","sourcesContent":[".wai-intro-notice {\n  position: fixed;\n  z-index: 10020;\n  width: 19rem;\n  padding: 0.9rem 0.9rem 0.75rem;\n  border: 1px solid #60a5fa;\n  border-radius: 0.7rem;\n  background: #eff6ff;\n  color: #1e3a5f;\n  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.2);\n  box-sizing: border-box;\n}\n\n.wai-intro-notice--left {\n  transform: translate(-100%, -50%);\n}\n\n.wai-intro-notice--below::after,\n.wai-intro-notice--left::after {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 0.45rem solid transparent;\n}\n\n.wai-intro-notice--left::after {\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  border-left-color: #60a5fa;\n}\n\n.wai-intro-notice--below::after {\n  left: 1.5rem;\n  bottom: 100%;\n  border-bottom-color: #60a5fa;\n}\n\n.wai-intro-notice__close {\n  position: absolute;\n  top: 0.3rem;\n  right: 0.3rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.7rem;\n  height: 1.7rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #60a5fa;\n  cursor: pointer;\n}\n\n.wai-intro-notice__close:hover {\n  color: #1d4ed8;\n}\n\n.wai-intro-notice__close svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n.wai-intro-notice__message {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.7rem;\n  padding-right: 1.15rem;\n}\n\n.wai-intro-notice__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 2rem;\n  width: 2rem;\n  height: 2rem;\n  overflow: hidden;\n  border: 1px solid rgba(209, 213, 219, 0.95);\n  border-radius: 999px;\n  background: #ffffff;\n}\n\n.wai-intro-notice__avatar svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.wai-intro-notice__message strong {\n  display: block;\n  margin-bottom: 0.2rem;\n  font-size: 0.84rem;\n}\n\n.wai-intro-notice__message p {\n  margin: 0;\n  font-size: 0.76rem;\n  line-height: 1.45;\n}\n\n.wai-intro-notice__dismiss {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin-top: 0.65rem;\n  padding-top: 0.55rem;\n  border-top: 1px solid rgba(37, 99, 235, 0.18);\n  font-size: 0.68rem;\n  color: #475569;\n  cursor: pointer;\n  user-select: none;\n}\n\n.wai-intro-notice__dismiss input {\n  width: 0.9rem;\n  height: 0.9rem;\n  margin: 0;\n  accent-color: #2563eb;\n  cursor: pointer;\n}\n\n.wai-intro-notice--dark {\n  border-color: #3b82f6;\n  background: #172554;\n  color: #dbeafe;\n  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.4);\n}\n\n.wai-intro-notice--dark.wai-intro-notice--left::after {\n  border-left-color: #3b82f6;\n}\n\n.wai-intro-notice--dark.wai-intro-notice--below::after {\n  border-bottom-color: #3b82f6;\n}\n\n.wai-intro-notice--dark .wai-intro-notice__dismiss {\n  border-top-color: rgba(96, 165, 250, 0.22);\n  color: #bfdbfe;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
